
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/roulette",
      function () {
        return require("private-next-pages/roulette.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/roulette"])
      });
    }
  